module.exports = __webpack_public_path__ + "static/media/45_Print.c1b3e1bd.png";